/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('HumanRoadsModalCtrl', function($scope, $window, Term, User, identity) {
    $scope.me = identity;

    $scope.my_user = User.me().$promise;

    return $scope.humanRoadsSSO = function() {
        if ((($scope.me != null ? $scope.me.groups : undefined) != null) && !Array.from($scope.me.groups).includes('student')) { return; }

        return $scope.my_user.then(my_user => Term.getMyPromo()
        .$promise
        .then(function(last_term) {
            const start = moment(last_term.learning_start);
            const end   = moment(last_term.learning_end);
            const diploma_name = (() => { switch (false) {
                case !last_term.term_name.match(/Master/i): return 'Master informatique';
                case !last_term.term_name.match(/Bachelor/i): return 'Bachelor informatique';
            } })();

            $window.hr.sso.auth('hr-sso', 'etna', {
                uuid: $scope.me.id,
                user: {
                    firstname: my_user.firstname,
                    lastname:  my_user.lastname,
                    email:     $scope.me.login + '@etna-alternance.net'
                },
                resume: [
                    {
                        type: 'diploma',
                        name: diploma_name,
                        major: last_term.spe,
                        start_year: start.format('YYYY'),
                        end_year: end.format('YYYY'),
                        location: [
                            {
                                name: 'Etna',
                                city: {
                                    name: 'Ivry-sur-Seine',
                                    country: 'France'
                                }
                            }
                        ]
                    }
                ]
            });

            return $window.hr.load();
        }));
    };
});
